import { Component, defineAsyncComponent } from 'vue'
import IconCheckDone1 from './design-system/assets/icons/IconCheckDone1.vue'
import IconInfoCircle from '@/design-system/assets/icons/IconInfoCircle.vue'
import IconInsertDriveFile from '@/design-system/assets/icons/IconInsertDriveFile.vue'
import IconLinkMedium from '@/design-system/assets/icons/IconLinkMedium.vue'
import IconTimeLine from '@/design-system/assets/icons/IconTimeLine.vue'
import IconPaperclip from './design-system/assets/icons/IconPaperclip.vue'
import ClockRefreshIcon from '@/design-system/assets/icons/IconClockRefresh.vue'
import ThermometerIcon from '@/design-system/assets/icons/IconThermometer.vue'
import IconAward from './design-system/assets/icons/IconAward.vue'
import IconTag from './design-system/assets/icons/IconTag.vue'
import IconUsers from './design-system/assets/icons/IconUsers.vue'
import IconTool2 from './design-system/assets/icons/IconTool2.vue'
import IconUserMinus from './design-system/assets/icons/IconUserMinus.vue'
import IconUserPlus from './design-system/assets/icons/IconUserPlus.vue'
import IconUsers01 from './design-system/assets/icons/IconUsers01.vue'
import IconZap from './design-system/assets/icons/IconZap.vue'
import IconClockRefresh from './design-system/assets/icons/IconClockRefresh.vue'
import IconGlobe2 from './design-system/assets/icons/IconGlobe2.vue'
import IconCalendarCheck from './design-system/assets/icons/IconCalendarCheck.vue'
import IconFileCheck2 from './design-system/assets/icons/IconFileCheck2.vue'
import IconSearch from './design-system/assets/icons/IconSearch.vue'
import IconPlusMedium from './design-system/assets/icons/IconPlusMedium.vue'
import IconTruck from './design-system/assets/icons/IconTruck.vue'
import IconMarkerPin from './design-system/assets/icons/IconMarkerPin.vue'
import IconMoveFolder from './design-system/assets/icons/IconMoveFolder.vue'
import IconCopySmall from './design-system/assets/icons/IconCopySmall.vue'
import IconMoveSmall from './design-system/assets/icons/IconMoveSmall.vue'
import IconFileSearch from './design-system/assets/icons/IconFileSearch.vue'
import IconEdit from './design-system/assets/icons/IconEdit.vue'
import IconEditSmall from './design-system/assets/icons/IconEditSmall.vue'
import IconMoreVertical from './design-system/assets/icons/IconMoreVertical.vue'
import IconDownload from './design-system/assets/icons/IconDownload.vue'
import IconArchive from './design-system/assets/icons/IconArchive.vue'
import IconTrash2Small from './design-system/assets/icons/IconTrash2Small.vue'
import IconTrash2Medium from './design-system/assets/icons/IconTrash2Medium.vue'
import IconPlusSquareSmall from './design-system/assets/icons/IconPlusSquareSmall.vue'
import IconChevronUpDownSmall from './design-system/assets/icons/IconChevronUpDownSmall.vue'
import IconColumn03 from './design-system/assets/icons/IconColumn03.vue'
import IconFolderSmall from './design-system/assets/icons/IconFolderSmall.vue'
import IconUpload from './design-system/assets/icons/IconUpload.vue'
import IconCamera from './design-system/assets/icons/IconCamera.vue'
import IconExternalLinkSmall from './design-system/assets/icons/IconExternalLinkSmall.vue'
import IconSmallPaperClip from './design-system/assets/icons/IconSmallPaperClip.vue'
import IconBox from './design-system/assets/icons/IconBox.vue'
import IconMark from './design-system/assets/icons/IconMark.vue'
import IconHomeWork from './design-system/assets/icons/IconHomeWork.vue'
import IconHome from './design-system/assets/icons/IconHome.vue'
import IconSmallHome from './design-system/assets/icons/IconSmallHome.vue'
import IconArrowUpRight from './design-system/assets/icons/IconArrowUpRight.vue'
import IconBook from './design-system/assets/icons/IconBook.vue'
import IconNavigateTo from './design-system/assets/icons/IconNavigateTo.vue'
import IconShare from './design-system/assets/icons/IconShare.vue'

export const icons: Record<string, Component> = {
  IconCheckDone1,
  IconBox,
  IconSearch,
  IconInfoCircle,
  IconInsertDriveFile,
  IconLinkMedium,
  IconTimeLine,
  IconPaperclip,
  ClockRefreshIcon,
  ThermometerIcon,
  IconAward,
  IconTag,
  IconUsers,
  IconTool2,
  IconUserMinus,
  IconUserPlus,
  IconZap,
  IconGlobe2,
  IconCalendarCheck,
  IconFileCheck2,
  IconClockRefresh,
  IconPlusMedium,
  IconTruck,
  IconMarkerPin,
  IconMoveFolder,
  IconFileSearch,
  IconEdit,
  IconEditSmall,
  IconMoreVertical,
  IconDownload,
  IconArchive,
  IconTrash2Small,
  IconTrash2Medium,
  IconPlusSquareSmall,
  IconChevronUpDownSmall,
  IconColumn03,
  IconFolderSmall,
  IconUpload,
  IconCamera,
  IconExternalLinkSmall,
  IconSmallPaperClip,
  IconCopySmall,
  IconMoveSmall,
  IconUsers01,
  IconMark,
  IconHomeWork,
  IconHome,
  IconSmallHome,
  IconArrowUpRight,
  IconBook,
  IconNavigateTo,
  IconShare
}

export const components: Record<string, Component> = {
  InfoDisplayDashboard: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayDashboard.vue')
  ),
  InfoDisplayAreasCard: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayAreasCard.vue')
  ),
  InfoDisplayApartmentsCard: defineAsyncComponent(
    () => import('./components/features/info-display/InfoDisplayApartmentsCard.vue')
  ),
  InfoDisplayContentCard: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayContentCard.vue')
  ),
  InfoDisplayIndoorDataCard: defineAsyncComponent(
    () => import('./components/features/info-display/InfoDisplayIndoorDataCard.vue')
  ),
  InfoDisplayInformationCard: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayInformationCard.vue')
  ),
  InfoDisplayOverview: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayOverview.vue')
  ),
  InfoDisplayPlaceCard: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayPlaceCard.vue')
  ),
  InfoDisplayRoomEdit: defineAsyncComponent(
    () => import('./components/features/info-display/InfoDisplayRoomEdit.vue')
  ),
  InfoDisplayLineSummaryCard: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayLineSummaryCard.vue')
  ),
  InfoDisplayZoneSummaryCard: defineAsyncComponent(
    () => import('@/components/features/info-display/InfoDisplayZoneSummaryCard.vue')
  ),
  CardChart: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/CardChart.vue')
  ),
  DashboardFeatureUsage: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/DashboardFeatureUsage.vue')
  ),
  DashboardFeature: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/DashboardFeature.vue')
  ),
  DashboardFeatureNew: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/DashboardFeatureNew.vue')
  ),
  DashboardDataSection: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/DashboardDataSection.vue')
  ),
  DashboardDataSectionFlat: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/DashboardDataSectionFlat.vue')
  ),
  DashboardDataSectionDynamic: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/DashboardDataSectionDynamic.vue')
  ),
  DashboardFeatureBuildingScore: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/BuildingScore/DashboardFeatureBuildingScore.vue')
  ),
  DividerComponent: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/DividerComponent.vue')
  ),
  KPISection: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/KPISection.vue')
  ),
  KPICard: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/cards/KPICard.vue')
  ),
  BuildingScoreKpiSection: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/BuildingScore/BuildingScoreKpiSection.vue')
  ),
  BuildingScoreGraphSection: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/BuildingScore/BuildingScoreGraphSection.vue')
  ),
  GraphSection: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/GraphSection.vue')
  ),
  HeatmapSection: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/HeatmapSection.vue')
  ),
  IndoorClimateFilters: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/IndoorClimate/IndoorClimateFilters.vue')
  ),
  ColorLegend: defineAsyncComponent(() => import('./design-system/atoms/ColorLegend.vue')),
  MeasurementCard: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/MeasurementCard.vue')
  ),
  CardHeatmap: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/CardHeatmap.vue')
  ),
  CardTopList: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/CardTopList.vue')
  ),
  CardTopListNew: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/CardTopListNew.vue')
  ),
  ProjectMeasurementCard: defineAsyncComponent(
    () => import('./components/project-analysis/ProjectMeasurementCard.vue')
  ),
  IndexMeasurementCard: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/IndoorClimate/IndexMeasurementCard.vue')
  ),
  MainMeasurementCard: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/MainMeasurementCard.vue')
  ),
  MainMeasurementCardNew: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/MainMeasurementCardNew.vue')
  ),
  FeatureCard: defineAsyncComponent(() => import('./components/FeatureCard.vue')),
  ProjectAnalysisFilters: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/ProjectAnalysisFilters.vue')
  ),
  PortfolioAnalysisFilters: defineAsyncComponent(
    () => import('@/components/portfolio-analysis/PortfolioAnalysisFilters.vue')
  ),
  ProjectListTable: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/components/ProjectListTable.vue')
  ),
  TicketListTable: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/tickets/TicketListTable.vue')
  ),
  TicketsDashboard: defineAsyncComponent(
    () => import('./components/features/tickets/TicketsDashboard.vue')
  ),
  TicketAnalysisFilters: defineAsyncComponent(
    () => import('@/components/AnalyticsDashboard/tickets/TicketAnalysisFilters.vue')
  ),
  AggregateAnalysisFilters: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/aggregate/AggregateAnalysisFilters.vue')
  ),
  InteractiveColorLegend: defineAsyncComponent(
    () => import('./design-system/molecules/InteractiveColorLegend.vue')
  ),
  TimeSeriesCard: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/TimeSeriesCard.vue')
  ),
  HistogramCard: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/HistogramCard.vue')
  ),
  BarChartCard: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/BarChartCard.vue')
  ),
  CardHeatmapNew: defineAsyncComponent(
    () => import('./components/AnalyticsDashboard/components/CardHeatmapNew.vue')
  ),
  FileDirectoryDashboard: defineAsyncComponent(
    () => import('./components/features/files/FileDirectoryDashboard.vue')
  ),
  IBinderDashboard: defineAsyncComponent(
    () => import('./components/features/ibinder/IBinderDashboard.vue')
  ),
  EntityDashboard: defineAsyncComponent(
    () => import('./components/features/entities/EntityDashboard.vue')
  ),
  AssetDashboard: defineAsyncComponent(
    () => import('./components/features/assets/AssetDashboard.vue')
  ),
  ProductDashboard: defineAsyncComponent(
    () => import('./components/features/products/ProductDashboard.vue')
  ),
  RentalObjectDashboard: defineAsyncComponent(
    () => import('./components/features/rental-objects/RentalObjectDashboard.vue')
  ),
  SystemDashboard: defineAsyncComponent(
    () => import('./components/features/systems/SystemDashboard.vue')
  ),
  ...icons
}

export default components
